// extracted by mini-css-extract-plugin
export default {"favStarBtn":"MarkFavoriteGoogleAddess_favStarBtn__gc+jp","favRate":"MarkFavoriteGoogleAddess_favRate__QpA+m"};